import React from "react";
import StyledInput from "../styledInput/StyledInput";

/**
 * Block component for managing Sunday Hours settings per company
 * Allows selecting which companies should have Sunday hours (code 1205) in Peopulse export
 */
function SundayHoursBlock({ companies, isWaiting, onSundayHoursChange }) {
  const selectedCount = companies.filter((c) => c.isSundayHours).length;

  return (
    <div className="py-3 px-4 flex justify-between gap-4 items-center">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col">
          <div className="font-bold">
            Majoration des heures du dimanche dans le fichier peopulse
          </div>
          <div>
            Une ligne avec le code 1205 sera ajoutée avec le total des heures
            travaillées pour chaque dimanche
          </div>
        </div>

        <div className="flex flex-col max-w-[330px]">
          {isWaiting ? (
            <div className="animate-pulse">
              <div className="h-12 bg-gray-200 rounded w-full"></div>
            </div>
          ) : (
            <StyledInput
              type="selectMultipleCheckbox"
              value={`${selectedCount} ${selectedCount === 1 ? "établissement" : "établissements"}`}
              list={companies.map((c) => ({
                value: c._id,
                label: c.name,
                checked: c.isSundayHours,
                id: c._id,
              }))}
              onChange={onSundayHoursChange}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SundayHoursBlock;
